import { di } from 'react-magnetic-di';
import { useProvider } from '@atlassian/unified-help-common/src/store/routing';
import { useActions as useAIAnswersActions } from '../../../store/converse';

export const useStopGenerating = () => {
    di(useProvider, useAIAnswersActions);
    const provider = useProvider();
    const { abortConversation } = useAIAnswersActions();

    const stopGenerating = () => {
        if (provider === 'AI_ANSWERS') {
            abortConversation();
        }
    };

    return { stopGenerating };
};
